import Vue from 'vue'
import Router from 'vue-router'

import AppView from '@/views/layout/app-view'
import Home from '@/views/home'

Vue.use(Router)

const page = name => () => import('@/views/' + name)

function returnIndex (){
  var indexMap = {
    "order.ushow.media" : "/ordertpl/list",
    "cdn.ushow.media" : "/cdnconfig/setting",
    "monitor.ushow.media" : "/monitor/setting",
    "italen.ushow.media" : "/italen/list",
    "password.ushow.media" : "/user/info/passwd",
    "cicd.ushow.media" : "/cicd/dashboard",
    "monitor_huidu.ushow.media" : "/monitor/custom",
    "monitor-huidu.ushow.media" : "/monitor/custom"
  }

  if(indexMap.hasOwnProperty(location.hostname)){
    return indexMap[location.hostname]
  }
  return "/cdnconfig/setting"
}




export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      component: AppView,
      children: [
        // {path: '/', name: 'home', component: Home, redirect: {path: '/meeting/order'}},
        {path: '/', name: 'home', component: Home, redirect: {path: returnIndex()}},
        // {path: '/', name: 'home', component: Home, redirect: {path: '/cdnconfig/setting'}},

        {path: '/meeting/order', name: 'meetingorder', component: page('meeting/index')},
        {path: '/meeting/detail/:id', name: 'meetingdetail', component: page('meeting/detail')},
      ]
    },
    {
      path: '',
      component: AppView,
      children: [
        {path: '/slowquery/list',name:'slowqueryList',component: page('slowquery/index')},
        {path: '/cdnconfig/setting',name:'cdnconfigSetting',component: page('cdnconfig/index')},
        {path: '/cdnconfig/job',name:'cdnconfigJob',component: page('cdnconfig/cdnJob'),meta:{"path":"/test1/"}},
        {path: '/cdnconfig/data',name:'cdnconfigData',component: page('cdnconfig/cdn-data')},
        {path: '/cdnconfig/info/:id',name:'cdnconfigJobInfo',component: page('cdnconfig/cdnJob-info')},
      ]
    },
    {
      path: '',
      component: AppView,
      children: [
        {path: '/monitor/setting', name: 'monitorSetting', component: page('monitor/index')},
        {path: '/monitor/list',name: 'monitorList', component: page('monitor/index_dashboard')},
        {path: '/monitor/maintian',name: 'monitorMantian',component: page( 'monitor/index_maintian')},
        {path: '/monitor/fastalarm',name:'monitorFastalarm',component:page('monitor/index_fastAlarm')},
        {path: '/monitor/report',name: 'monitorReport',component:page('monitor/monitor_report')},
        {path: '/monitor/custom', name: 'monitorCustom', component: page('monitor/index_custom')},
        {path: '/monitor/alarmGroup', name: 'monitorGroup', component: page('monitor/index_alarmGroup')},
        {path: '/monitor/prometheus', name: 'monitorPrometheus', component: page('monitor/index_prometheus')}
      ]
    },
    {
      path: '',
      component: AppView,
      children: [
        {path: '/italen/list', name: 'italen', component: page('italen/index')},
      ]
    },
    {
      path: '',
      component: AppView,
      children: [
        // {path: '/corder/list', name: 'corder', component: page('corder/index')},
        {path: '/ordertpl/list', name: 'ordertpl', component: page('ordertpl/index')},
        {path: '/workorder/create/:id', name: 'createorder', component: page('createorder/index')},
        {path: '/suborder/modify/:id', name: 'modifyorder', component: page('modifyorder/index')},
        {path: '/submitted/order', name: 'submitted', component: page('submitorder/index')},
        {path: '/suborder/approve/:id', name: 'suborder', component: page('suborder/index')},
        {path: '/suborder/approve/:type/:id/:user/:token', name: 'suborderWx', component: page('suborder/index')},
        {path: '/suborder/log/:id', name: 'suborderlog', component: page('suborder/log')},
        {path: '/user/info', name: 'userinfo', component: page('userinfo/index')},
        {path: '/user/info/passwd/:token', name: 'userNewPasswd', component: page('userinfo/newPasswd')},
        {path: '/user/info/passwd', name: 'userpasswd', component: page('userinfo/passwd')},
      ]
    },
    {
      path: '',
      component : AppView,
      children: [
        {path: "cicd/dashboard",name:'cicddashboard',component:page('cicd/index')}
      ]
    },
    {
      path: '',
      component: AppView,
      children: [
        {path: 'manage/submitted/order', name: 'managesubmitted', component: page('managesubmitorder/index')},
        {path: 'manage/flowconf', name: 'manageflowconf', component: page('manageflowconf/index')},
        {path: 'manage/flowroleconf/:id', name: 'manageflowroleconf', component: page('manageflowroleconf/add')},
        {path: 'manage/flowroleconfmodify/:id', name: 'manageflowroleconfmodify', component: page('manageflowroleconf/add')},
        {path: 'manage/flowroleconf/list/:id', name: 'manageflowroleconflist', component: page('manageflowroleconf/index')},

      ]
    },
    {path: '/login', name: 'login', component: page('login')},
    {path: '/mb/meeting/order', name: 'mbmeetingorder', component: page('mb/meeting/index')},
    {path: '/mb/monitor/report', name: 'mbmonitorReport', component: page('mb/monitor/index')},
    {path: '/mb/meeting/detail/:id', name: 'mbmeetingdetail', component: page('mb/meeting/detail')},
    {path: '/mb/suborder/approve/:id',name: 'mbsuborder',component: page('mb/suborder/index')},
    {path: '/mb/suborder/approve/:type/:id/:user/:token',name: 'mbsuborderWx',component: page('mb/suborder/index')},
    {path: '/mb/user/info', name: 'profile', component: page('mb/profile/index')},
    {path: '/templates', name: 'templates', component: page('ordertpl/index2')},
    {path: '/callback', name: 'callback', component: page('callback')},

    // pages
    {path: '*', redirect: {name: '404'}}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js